import api from './api';
import { getCurrentUser, authFetch } from './authService';

// Definir interfaz para cliente
export interface Cliente {
  id?: number;
  nombre: string;
  razon_social: string;
  cuit?: string;
  email?: string;
  telefono?: string;
  direccion?: string;
  ciudad?: string;
  provincia?: string;
  estado?: number;
  p_busqueda?: boolean;
  p_carga?: boolean;
  p_modif_analisis?: boolean;
  p_nuevo_analisis?: boolean;
  p_pendientes?: number;
  apellido_usuario?: string;
  id_usuario?: number;
}

// Obtener todos los clientes
export const getClientes = async (): Promise<Cliente[]> => {
  // Sin datos de ejemplo de respaldo: un listado inventado haría elegir un
  // cliente que no existe y dejaría el análisis apuntando a la nada.
  const response = await api.get('/clientes');
  return response.data;
};

// Obtener un cliente por ID
export const getClienteById = async (id: number): Promise<Cliente | null> => {
  try {
    const response = await api.get(`/clientes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener cliente por ID:', error);
    return null;
  }
};

// Obtener cliente actual (si el usuario es cliente)
export const getClienteActual = async (): Promise<Cliente | null> => {
  try {
    // Obtener el ID del usuario actual del localStorage
    const userDataString = localStorage.getItem('user');
    
    if (!userDataString) {
      return null;
    }
    
    const userData = JSON.parse(userDataString);
    const userId = userData.id;
    
    if (!userId) {
      return null;
    }
    
    // Buscar el cliente asociado a este usuario
    const response = await api.get(`/clientes?id_usuario=${userId}`);
    
    if (response.data && response.data.length > 0) {
      return response.data[0]; // Devolver el primer cliente asociado
    }
    
    return null;
  } catch (error) {
    console.error('Error al obtener cliente actual:', error);
    
    // Si hay un error, podemos intentar obtener datos estáticos de cliente como fallback
    try {
      const staticResponse = await api.get('/clientes');
      if (staticResponse.data && staticResponse.data.length > 0) {
        return staticResponse.data[0]; // Devolver el primer cliente como ejemplo
      }
    } catch (fallbackError) {
      console.error('Error al obtener datos estáticos de cliente:', fallbackError);
    }
    
    return null;
  }
};

// Crear un nuevo cliente
export const createCliente = async (cliente: Cliente): Promise<Cliente> => {
  const response = await api.post('/clientes', cliente);
  return response.data;
};

// Actualizar un cliente
export const updateCliente = async (id: number, cliente: Partial<Cliente>): Promise<Cliente> => {
  const response = await api.put(`/clientes/${id}`, cliente);
  return response.data;
};

// Eliminar un cliente. La baja es lógica: el cliente y todos sus usuarios pasan
// a estado 2, dejan de verse en la aplicación y el historial se conserva.
export const eliminarCliente = async (id: number): Promise<void> => {
  await api.delete(`/clientes/${id}`);
}; 